export const connectionType = import.meta.env.PROD ? undefined : 4;

export const hubs = {
  projectAssistant: "/projectAssistantHub",
};
